import RichText from '@rsa-digital/evo-shared-components/components/RichText';
import colors from '@rsa-digital/evo-shared-components/helpers/colors';
import fonts from '@rsa-digital/evo-shared-components/helpers/fonts';
import mediaQuery from '@rsa-digital/evo-shared-components/helpers/mediaQuery';
import spacing from '@rsa-digital/evo-shared-components/helpers/spacing';
import styled from 'styled-components';

export const PageWrapper = styled.div`
  padding-top: 3.5rem;
`;

export const ContentContainer = styled.div`
  display: none;

  ${mediaQuery.tabletLandscape` 
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    width: 75%;
  `}

  ${mediaQuery.desktop`
    width: 50%;
  `}
`;

export const Curve = styled.div<{ backgroundUrl: string }>`
  display: none;

  ${mediaQuery.desktop`
    background-image: url('${({ backgroundUrl }) => backgroundUrl}');
    display: block;
    height: 650px;
    margin-left: calc(80% - 100vw);
    background-repeat: repeat-x;
  `}
`;

export const Heading = styled.h1`
  color: ${colors.neutral08};
  font-size: 3.25rem;
  line-height: 3.75rem;
  margin-top: ${spacing(1.5)};
  margin-bottom: ${spacing(1.5)};

  ${mediaQuery.tabletPortrait`
    margin-top: 0;
  `}

  ${mediaQuery.tabletLandscape`
    margin-top: ${spacing(1.5)};
    margin-bottom: ${spacing(2)};
    ${fonts.headingXLarge};
    & {
      color: ${colors.neutral08};
      line-height: 80px;
    }
  `}
`;

export const ImageWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  /* display: flex;
  justify-content: flex-end; */
  width: 100vw;
  margin: 0 calc(50% - 50vw);
  z-index: -1;
`;

export const MobileContainer = styled.div``;

export const MobileContentWrapper = styled.div`
  padding: ${spacing(3)};
  position: absolute;
  top: 8.31rem;
`;

export const MobileCurve = styled.div<{ backgroundUrl: string }>`
  background-image: url('${({ backgroundUrl }) => backgroundUrl}');
  display: block;
  height: 484px;
  margin-left: calc(70% - 100vw);
  background-repeat: repeat-x;

  ${mediaQuery.desktop`
    display: none;
  `}
`;

export const Subhead = styled(RichText)`
  ${fonts.paragraph};
  color: white;
`;

export const Wrapper = styled.div`
  position: relative;
  ${mediaQuery.tabletLandscape`
    margin: 0 calc(50% - 50vw);
    padding: 0 calc(50vw - 50%);
  `}
`;
